import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NavigationListener = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleNavigation = () => {
            navigate("/dashboard");
        };

        window.addEventListener("NAVIGATE", handleNavigation);
        return () => {
            window.removeEventListener("NAVIGATE", handleNavigation);
        };
    }, [navigate]);

    return null;
};

export default NavigationListener;
